// src/context/ConsentContext.js
import { createContext, useContext, useMemo, useState } from "react";
import { getConsent, setConsent as setConsentStorage } from "../analytics/tracker";

const ConsentContext = createContext(null);

export const ConsentProvider = ({ children }) => {
  // odluka da li je korisnik kliknuo bilo šta (prihvatio/odbio/snimio)
  const [decision, setDecision] = useState(() => {
    return localStorage.getItem("CookieConsentDecision") === "1";
  });

  // modal/settings switch
  const [isBannerVisible, setIsBannerVisible] = useState(() => !decision);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const acceptAll = () => {
    localStorage.setItem("CookieConsentDecision", "1");
    setDecision(true);
    setIsBannerVisible(false);

    setConsentStorage({ analytics: true, marketing: true });

    window.gtag?.("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
    });
  };

  const rejectAll = () => {
    localStorage.setItem("CookieConsentDecision", "1");
    setDecision(true);
    setIsBannerVisible(false);

    setConsentStorage({ analytics: false, marketing: false });

    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
    });
  };

  const saveChoices = ({ analytics, marketing }) => {
    localStorage.setItem("CookieConsentDecision", "1");
    setDecision(true);
    setIsBannerVisible(false);

    setConsentStorage({ analytics, marketing });

    window.gtag?.("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: marketing ? "granted" : "denied",
    });
  };

  const openSettings = () => {
    setIsSettingsOpen(true);
    setIsBannerVisible(true); // prikaži banner kao modal/settings UI
  };

  const closeSettings = () => setIsSettingsOpen(false);

  const value = useMemo(() => {
    return {
      decision,
      isBannerVisible,
      isSettingsOpen,
      acceptAll,
      rejectAll,
      saveChoices,
      openSettings,
      closeSettings,
      getConsent, // helper
    };
  }, [decision, isBannerVisible, isSettingsOpen]);

  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
};

export const useConsent = () => useContext(ConsentContext);